import config from "config";

const NextRouteURLs = {
  HOME: config.basePath,
  CONTACT: `${config.basePath}/contact`,
  SPACE_COMPETITION: `${config.basePath}/spacecompetition`,
  HOW_IT_WORKS: `${config.basePath}/how-it-works`,
  SPACES: `${config.basePath}/spaces`,
  SOOK_VISION: `${config.basePath}/sook-vision`,
  PARTNERS: `${config.basePath}/partners`,
  BLOG: `${config.basePath}/blog`,
  PRESS_AND_AWARDS: `${config.basePath}/press-and-awards`,
  PRIVACY: `${config.basePath}/privacy`,
  TERMS_AND_CONDITIONS: `${config.basePath}/terms-and-conditions`,
  FAQ: `${config.basePath}/faq`,
};

export default NextRouteURLs;
